import { IS_MIRTURBAZ } from './filter_main.js.jsx';

export default class CampCardServices extends React.Component {
  constructor(props) {
    super(props);
  }

  renderFoodTypeName() {
    const { tariff, foodTypeName, isSeparator, validSearch } = this.props;
    const tariffFoodName = validSearch
      ? tariff?.food_name_for_food_filter || tariff?.food_name || 'Без питания'
      : tariff?.food_name;

    return foodTypeName == null ? (
      <div>
        {tariffFoodName ? (
          <span className="card__desc-info-list-item_food">
            <div className="card__desc_img-block">
              <div className="card__desc-info-list-item_food-img"></div>
            </div>
            {tariffFoodName}
            {isSeparator && this.freeCancellation() ? " · " : null}
          </span>
        ) : null}
      </div>
    ) : (
      <div>
        {foodTypeName ? (
          <span className="card__desc-info-list-item_food">
            <div className="card__desc_img-block">
              <div className="card__desc-info-list-item_food-img"></div>
            </div>
            {foodTypeName}
            {isSeparator && this.freeCancellation() ? " · " : null}
          </span>
        ) : null}
      </div>
    );
  }

  freeCancellation() {
    if (!this.props.isFreeCancellation || IS_MIRTURBAZ) return null;
    return (
      <div className="card__tags_sanatoriums-tag">
        <div className="card__desc_img-block">
          <div className="card__tags_sanatoriums-tag-icon"></div>
        </div>
        Бесплатная отмена
      </div>
    );
  }

  instantBooking() {
    if (!this.props.instantBooking) return null;
    return (
      <div className="card__instant_sanatoriums-booking">
        <div className="card__desc_img-block">
          <div className="card__instant_sanatoriums-booking-img"></div>
        </div>
        Моментальное подтверждение
      </div>
    );
  }

  notRequiredPrepayment() {
    if (!this.props.notRequiredPrepayment) return null;
    return (
      <div className="card__required_prepayment">
        <div className="card__desc_img-block">
          <div className="card__required_prepayment-img"></div>
        </div>
        Оплата при заселении
      </div>
    );
  }

  render() {
    const { campsLoaded, showAllCamps, minPrice } = this.props;
    const isVisibleTags = (showAllCamps && campsLoaded && minPrice) || !showAllCamps;
    return (
      <div>
        <div className={'card__desc_food-block'}>
          {this.renderFoodTypeName()}
          {this.freeCancellation()}
        </div>

        {isVisibleTags ? ([this.instantBooking(), this.notRequiredPrepayment()]) : null}
      </div>
    );
  }
}
